<template>
    <div :class="['right-arrow-text', wrapperClass]">
        <div class="inner-box" @click="$emit('click')">
            <span class="text">{{ text }}</span>
            <i :class="['icon icon-bor-arrow-right text-primary pl-2', iconClass]"></i>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'RightArrowText',
    props: {
        text: {
            type: String,
            default: 'フォトギャラリーを見る'
        },
        wrapperClass: {
            type: String,
            default: ""
        },
        iconClass: {
            type: String,
            default: ""
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>  